import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function Draggable(): React.ReactElement {
  return (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <circle cx="1.56247" cy="1.56247" r="1.56247" />
      <circle cx="1.56247" cy="7.68747" r="1.56247" />
      <circle cx="1.56247" cy="13.8125" r="1.56247" />
      <circle cx="6.68844" cy="1.56247" r="1.56247" />
      <circle cx="6.68747" cy="7.68747" r="1.56247" />
      <circle cx="6.68747" cy="13.8125" r="1.56247" />
    </svg>
  );
}
